import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PackingListItemEditComponent, PackingListItemListComponent, PackingListItemViewComponent } from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { RouterModule } from '@angular/router';

import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [PackingListItemEditComponent, PackingListItemListComponent, PackingListItemViewComponent],
  imports: [CommonModule, MutualModule, NgxPaginationModule, PipesSharedModule, FormWrapperModule, RouterModule],
  exports: [PackingListItemEditComponent, PackingListItemListComponent, PackingListItemViewComponent],
})
export class PackingListItemsModule {}
